module.exports = __webpack_public_path__ + "img/guribe.90c45151.jpg";